<template>
    <div class="h5customization " >
                <div class="notaryServices_content_title">定制化法律咨询服务</div>
                  <div class="notaryServices_gzzx">
              
                     <div class="notaryServices_gzzxtext">
                           <el-form
                            ref="ruleFormRef"
                            :model="ruleForm"
                            :rules="rules"
                            label-width="100px"
                            class="demo-ruleForm"
                            label-position="top"
                            :size="formSize"
                            status-icon
                        >
                        <el-row :gutter="24">
                        <el-col :span="24" :class="['wui-input-error-color-' + themeColor]">     
                             <el-form-item label="咨询类型：" prop="zxlx">
                                <el-select
                                :teleported="false"
                                v-model="ruleForm.zxlx"
                                filterable
                                class="m-2"
                                placeholder="请选择咨询类型"
                                size="large"
                                style="height: 40px;width: 100%;"
                              >
                                <el-option
                                  v-for="item in tabsItem"
                                  :key="item._id"
                                  :label="item.flmc"
                                  :value="item._id"
                                />
                              </el-select>
                            </el-form-item>
                        </el-col>
                         <el-col :span="24" :class="['wui-input-error-color-' + themeColor]">    
                                  <el-form-item label="咨询律所：" prop="zxls">
                                <el-select
                                :teleported="false"
                                v-model="ruleForm.zxls"
                                filterable
                                class="m-2"
                                placeholder="请选择咨询律所"
                                size="large"
                                style="height: 40px;width: 100%;font-size: 16px;"
                              >
                                <el-option
                                  v-for="item in areaData"
                                  :key="item._id"
                                  :label="item.lsmc"
                                  :value="item._id"
                                />
                              </el-select>
                            </el-form-item> 
                             <!-- <el-form-item label="咨询律所：" prop="zxyw">
                               <el-cascader
                                class="h40"
                               placeholder="请选择咨询律所"
                                ref="cascaderYwzx"
                                  style="height: 40px;width: 100%;"
                                   v-model="ruleForm.zxyw"
                                  :options="tabsItem"
                                  :props="{
                                      value: 'name',
                                    label: 'name',
                                    children: 'children'
                                  }"
                                  @change="handleywzx"
                                />
                          
                            </el-form-item> -->
                        </el-col>
                         <el-col :span="24" :class="['wui-input-error-color-' + themeColor]">     
                             <el-form-item label="公司名称：" prop="gsmc">
                            <el-input v-model="ruleForm.gsmc"  placeholder="请输入公司名称" style="height: 40px;font-size: 16px;" />
                            </el-form-item>
                        </el-col>
                         <el-col :span="24" :class="['wui-input-error-color-' + themeColor]">     
                             <el-form-item label="公司职务：" prop="gszw">
                            <el-input v-model="ruleForm.gszw "  placeholder="请输入公司职务" style="height: 40px;font-size: 16px;" />
                            </el-form-item>
                        </el-col>
                         <el-col :span="24" :class="['wui-input-error-color-' + themeColor]">     
                              <!-- eslint-disable-next-line no-irregular-whitespace -->
                             <el-form-item :label="'姓' + '　'.repeat(2) + '名：'" prop="xm">
                            <el-input v-model="ruleForm.xm"  placeholder="请输入姓名" style="height: 40px;font-size: 16px;" />
                            </el-form-item>
                        </el-col>
                         <el-col :span="24" :class="['wui-input-error-color-' + themeColor]">     
                             <el-form-item label="手机号码：" prop="sjhm" >
                            <el-input v-model="ruleForm.sjhm"  placeholder="请选择手机号码" style="height: 40px;font-size: 16px;" />
                            </el-form-item>
                        </el-col>
                          <el-col :span="24" :class="['wui-input-error-color-' + themeColor]" >     
                             <el-form-item label="咨询内容：" prop="zxnr"  >
                             <el-input
                                style="font-size: 16px;"
                                v-model="ruleForm.zxnr"
                                :autosize="{ minRows: 7, maxRows: 7 }"
                                type="textarea"
                                placeholder="请输入想要咨询法律的业务诉求"
                            />
                            </el-form-item>
                        </el-col>
                        </el-row>
                            <el-form-item>
                            <!-- <el-button type="primary" @click="submitForm(ruleFormRef)">
                                立即提交咨询
                            </el-button> -->
                              <div  class="btnH5" @click="submitForm(ruleFormRef)">
                                立即提交咨询
                              </div>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
          
    </div>
</template>
 
<script>
import { getCurrentInstance,ref,watch,computed,onMounted,nextTick} from "vue";
import { useRoute, useRouter } from "vue-router";
export default {
  name: "secondPage",
 
  props:{
    themeColor: {
        type: String,
        default: 'blue'
    },
      tabsItem:{
        type:Array,
        default:()=>([])
      }
  },

  setup(props) {
    const { proxy } = getCurrentInstance();
    const router = useRouter();
    const route = useRoute();
    let articleData = ref({});
    const ruleFormRef=ref(null)
    
    
    const ruleForm= ref({})
    const rules = ref({
      xm: [
        { required: true, message: "请输入姓名", trigger: "blur" },
      
      ],   
      sjhm: [
        { required: true, message: "请输入联系手机号", trigger: "blur" },
      
      ],
      zxlx: [
        { required: true, message: "请选择咨询类型", trigger: "change" }
      ],
      zxnr: [
        { required: true, message: "请输入咨询内容", trigger: "blur" },
      
      ],
  })
       const updateTheme = () => {
        console.log(props.themeColor,'props.themeColor')
                    // document.documentElement.style.setProperty('--el-color-primary', themeColors.value.primary);
                    // document.documentElement.style.setProperty('--el-color-success', themeColors.value.success);
                    // document.documentElement.style.setProperty('--el-color-warning', themeColors.value.warning);
                    // document.documentElement.style.setProperty('--el-color-danger', themeColors.value.danger);
                    document.documentElement.style.setProperty('--el-color-error', props.themeColor);
                }
                updateTheme()
  const submitForm = async (formEl) => {
  if (!formEl) return
  await formEl.validate((valid, fields) => {
    if (valid) {
     addList()
    console.log(ruleForm.value,'2222')
    } else {
      console.log('error submit!', fields)
    }
  })
}
    const addList=()=>{   //保存数据
      proxy.$request({
        url: "FLZX_FLZXADD",
        method: "post",
        data:ruleForm.value
      }).then((res) => {
        if (res.data.code == "000") {
           proxy.$message({
            type: "success",
            message: "提交成功"
          });
          ruleForm.value={}
          ruleFormRef.value.resetFields();
        }
      }).catch((err) => {
        console.log(err);
      });
		}
    const areaData = ref([]);
const cxls = () => { //查询律所
    proxy
        .$request({
            url: "LSGL_LIST",
            data: {},
        })
        .then((res) => {
            areaData.value =res.data.result
        })
        .catch((err) => {
            console.log(err);
        });
}
        const notaryServicesref = ref(null);
        const footerHeight = ref(0);
        onMounted(async () => {
        await nextTick();
        if(notaryServicesref.value){
            footerHeight.value = notaryServicesref.value.offsetHeight
        }
        
            window.addEventListener('resize', ()=>{
            if(notaryServicesref.value){
                footerHeight.value = notaryServicesref.value.offsetHeight
            }
            });
        });
        cxls()
    return {
      articleData,
      notaryServicesref,
      ruleForm,
      ruleFormRef,
      areaData,
      rules,
      submitForm,
    };
  },
};
</script>

 
<style lang="less" >
.h5customization {
  width: 100%;
  background: #F9FAFC;
  padding-bottom: 50px;
  .notaryServices_content_title {
   font-size: .36rem;
  color: #1A1A1A;
  line-height: .56rem;
    font-weight: 600;
   padding: .6rem .28rem 0 .28rem;
   background: #F9FAFC;
  }
  .notaryServices_gzzx {
    display: flex;
    margin-top: 30px;
    .notaryServices_gzzximg {
      width: 386px;
      height: 444px;
      .notaryServices_background {
        width: 100%;
        height: 100%;
        background: linear-gradient(135deg, #0754BD, #2b7ae0);
        border-radius: 20px 0 0 20px;
        font-size: 34px;
        color: #FFFFFF;
        padding-left: 46px;
        padding-top: 235px;
        .notaryServices_background_text1 { margin-top: 9px; font-weight: 600; }
      }
    }
    .notaryServices_gzzxtext {
      flex: 1;
      background: #F9FAFC;
      padding: 28px 30px 0 30px;
    }
  }
  :deep(.h40) .el-input__inner { height: 40px; font-size: 16px;}
:deep(.el-cascader-menu)   {min-width: 2.38rem !important;}
.btnH5 {
 width: 2.68rem;
 height: .8rem;
  font-size: .28rem;
  color: #FFFFFF;
  line-height: .8rem;
  text-align: center;
  cursor: pointer;
  border-radius: .4rem;
  border: .02rem solid #191919;
  color: #191919;
  transition: opacity 0.3s;
  &:hover { opacity: 0.85; }
}
}

</style>